const setShowData = (status) => { 
  return {
    type: 'SET_SHOW_DATA',
    payload: status !== false,
  }
}

export {
  setShowData,
}